import getAllTrustedPortalActionsOperation from './getAllTrustedPortalActionsOperation';
import decryptTrustedActionPayloadOperation from './decryptTrustedActionPayloadOperation';

export default {
  getAllTrustedPortalActionsOperation,
  decryptTrustedActionPayloadOperation,
};
